import { Page } from "@/models/page-models/Page";

export const TradingOrderOut: Page = {
  "path": "trading-order-out",
  "name": "Trading Order Out",
  "props": {
    "data": {
      "title": "Trading Order Out",
      "printable": "FALSE",
      "url": "trading-order-out",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.q.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.q.endDate",
                  "label": "End Date",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.q.customer",
                  "label": "Select Customer",
                  "disabled": "FALSE",
                  "items": "fetchedData.customer.data",
                  "itemText": "alias",
                  "itemValue": "_id",
                  "multiple": true
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.q.productLine",
                  "label": "Product Line",
                  "disabled": "FALSE",
                  "items": "fetchedData.productLines.data.0.data",
                  "itemText": "name",
                  "itemValue": "name",
                  "multiple": true
                },
                {
                  "type": "input",
                  "variable": "fetchedData.q.productAlias",
                  "label": "Search Product Alias",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyCurrentDate",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultDateValues",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.q"
                      },
                      "name": "copyCurrentDate"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyProductLineFilter",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.q.productLine",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.q.productLine"
                      },
                      "name": "copyProductLineFilter",
                      "executeIf": "fn(LENGTH,{{fetchedData.q.productLine}})"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyCustomerFilter",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.q.customer",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.q.customer"
                      },
                      "name": "copyCustomerFilter",
                      "executeIf": "fn(LENGTH,{{fetchedData.q.customer}})"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyProductAliasFilter",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.q.productAlias",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.q.productAlias"
                      },
                      "name": "copyProductAliasFilter",
                      "executeIf": "fn(LENGTH,{{fetchedData.q.productAlias}})"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "getTradingOrdersOut",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/order/trading-order-out",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.orders",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getTradingOrdersOut"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "4b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Trading Orders Out",
                  "disabled": "FALSE",
                  "items": "fetchedData.orders.data",
                  "headers": [
                    {
                      "value": "invoiceDate",
                      "text": "Invoice\\nDate",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.invoiceDate}})"
                    },
                    {
                      "value": "_id",
                      "text": "Order #",
                      "type": "url",
                      "url": "/order/{{__item._id}}"
                    },
                    {
                      "value": "customer.alias",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "__item.customerPO",
                      "text": "Customer\\nPO#"
                    },
                    {
                      "value": "product._id",
                      "text": "Product\\nID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "productLine",
                      "text": "Product\\nLine"
                    },
                    {
                      "value": "product",
                      "text": "Product",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "unit.unit2",
                      "text": "Unit"
                    },
                    {
                      "value": "pcsPerPackage",
                      "text": "Pcs Per\\nRoll/Carton",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.pcsPerPackage}},true)"
                    },
                    {
                      "value": "packageQty",
                      "text": "Roll/Carton\\nQuantity",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.packageQty}},true)"
                    },
                    {
                      "value": "totalQuantity",
                      "text": "Total\\nQuantity",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.totalQuantity}},true)"
                    },
                    {
                      "value": "unitPrice",
                      "text": "Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.unitPrice}})"
                    },
                    {
                      "value": "invoiceSubtotal",
                      "text": "SubTotal",
                      "formula": "fn(HELPER_FN,currency,{{__item.invoiceSubtotal}})"
                    },
                    {
                      "value": "invoiceTotal",
                      "text": "Total",
                      "formula": "fn(HELPER_FN,currency,{{__item.invoiceTotal}})"
                    },
                    {
                      "value": "invoiceId",
                      "text": "Invoice #",
                      "type": "url",
                      "url": "/invoice/{{__item.invoiceId}}"
                    },
                    {
                      "value": "loadingManifest",
                      "text": "LM #",
                      "type": "url",
                      "url": "/loading-manifest/{{__item.loadingManifest}}"
                    },
                    {
                      "value": "trackingNumber",
                      "text": "LM\\nTracking#"
                    }
                  ],
                  "tableType": "static",
                  "height": "70vh",
                  "footer": {
                    "invoiceSubtotal": "fn(HELPER_FN,currency,fn(ARRAY_SUM,{{__item.invoiceSubtotal}},{{fetchedData.orders.data}}))",
                    "invoiceTotal": "fn(HELPER_FN,currency,fn(ARRAY_SUM,{{__item.invoiceTotal}},{{fetchedData.orders.data}}))"
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer"
        },
        "name": "getCustomers"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getProductLines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=product-lines1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productLines"
        },
        "name": "getProductLines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "resetFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getEmptyFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "resetFilters"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyDefaultDate",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultDateValues",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.q",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultDate"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getTradingOrdersOut",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/order/trading-order-out",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.orders",
          "arg3Key": "postData",
          "arg3Value": "formData"
        },
        "name": "getTradingOrdersOut"
      }
    ],
    "functions": [
      {
        "name": "getEmptyFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {}
        },
        "staticObject": true
      },
      {
        "name": "getDefaultDateValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "startDate": "fn(CONDITIONAL,fn(NOT,{{formData.q.startDate}}),{{MONTH_START}},{{formData.q.startDate}})",
          "endDate": "fn(CONDITIONAL,fn(NOT,{{formData.q.endDate}}),{{TODAYS_DATE}},{{formData.q.endDate}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_INBOUND_WAREHOUSE",
  "visible": true,
  "menuGroup": "Reports"
}